export default __webpack_public_path__ + "static/media/Freundliche-Landschaft.3c4a69d1.mp3";